

import { mapState } from 'vuex'
import ObfuscateTooltip from '@/components/catalog/ObfuscateTooltip'
import gmapsInit from '@/components/tools/gmaps'

export default {
  name: 'ProductLocation',
  components: { ObfuscateTooltip },
  props: {
    lat: {
      type: Number,
      required: true
    },
    lon: {
      type: Number,
      required: true
    },
    zipcode: {
      type: String,
      default: undefined
    },
    countryCode: {
      type: String,
      default: undefined
    },
    country: {
      type: String,
      default: undefined
    },
    city: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      map: null,
      marker: null
    }
  },

  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true

    }),
    ...mapState('product', {
      distanceToMyLocation: state => state.data?.context?.distanceToMyLocation + ' km'
    })
  },
  async mounted () {
    try {
      const center = { lat: this.lat, lng: this.lon }
      const { locale } = this.$i18n

      const google = await gmapsInit(locale)

      this.map = new google.maps.Map(this.$refs.map, {
        zoom: 10,
        center,
        mapId: '6296be01c5b101b9'
        // `language` is not a MapOptions field — it is a loader URL parameter, and
        // gmapsInit already passes the visitor's locale there. Hardcoding 'de' here
        // did nothing except contradict the other seven locales.
      })

      // AdvancedMarkerElement replaces google.maps.Marker, which the API now logs a
      // deprecation warning for on every product page. The fallback covers the case
      // where the marker library did not load — a deprecated marker still beats no
      // marker, and errors thrown inside the Maps bundle are invisible to us.
      const AdvancedMarkerElement = google.maps.marker?.AdvancedMarkerElement

      this.marker = AdvancedMarkerElement
        ? new AdvancedMarkerElement({
          position: center,
          map: this.map
        })
        : new google.maps.Marker({
          position: center,
          map: this.map
        })
    } catch (error) {
      console.error(error)
    }
  },
  methods: {}
}
